export const freeCancellationRolloutMarkets = [
  "ES",
  "OPES",
  "PT",
  "OPPT",
  "GB",
  "OPGB",
  "UK",
  "OPUK",
  "IT",
  "OPIT",
  "FR",
  "OPFR",
  "GOFR",
  "CH",
  "OPCH",
  "OPAT",
];

export const isFreeCancellationRolloutMarket = (site: string): boolean =>
  freeCancellationRolloutMarkets.includes(site);
